import { useSelector } from 'react-redux'

import { faPlus } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../../../antd/Buttons/IconButton'
import { Institution } from '../../../../utils/entities/institution'
import InstitutionsSelector from './InstitutionsSelector'
import InstitutionModal from '../../../../Providers/Forms/InstitutionModal/InstitutionModal'
import { ModalTypes } from '../../../../Providers/Forms/IndividualInternshipRequest/IndividualInternshipRequestModal'

const ExtendedInstitutionsSelector = ({
  className = '', disabled, dropdownDisabled, institutions = null, multiple = 'default', style = {}, values, onChange, onInstitutionSubmit
}) => {
  const t = useSelector(selectTranslate)

  const renderDropdown = onClick => menu => (
    <div>
      {menu}
      <div className='flex-col m-4' onMouseDown={e => e.preventDefault()}>
        <IconButton
          text={t('form.request.new_institution')}
          icon={faPlus}
          onClick={() => onClick(handler => ({ ...handler, data: new Institution(), callback: onInstitutionSubmit, type: ModalTypes.STUDENT }))}
        />
      </div>
    </div>
  )

  return (
    <InstitutionModal>
      <InstitutionsSelector
        className={className}
        disabled={disabled}
        multiple={multiple}
        institutions={institutions}
        style={style}
        values={values}
        dropdownRender={!dropdownDisabled && renderDropdown}
        onChange={onChange}
      />
    </InstitutionModal>
  )
}

export default ExtendedInstitutionsSelector
